var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdgeTab = function SvgEdgeTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.188,
    height: 17.043
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Edge Tab",
    fill: "#fff",
    stroke: "#4e4e4e",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 203",
    d: "m15.135.256 10.138 1.613a2.857 2.857 0 0 1 1.152.553 1.2 1.2 0 0 1 .276.921l.23 6.729-14.424 6.451-.185-8.249L1.078 5.325l-.276-.323Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 202",
    d: "M.25 4.818v8.249l12.212 3.641V8.135a1.112 1.112 0 0 0-.415-1.014 4.612 4.612 0 0 0-1.659-.553Z"
  }))));
};
export default SvgEdgeTab;